export default __webpack_public_path__ + "static/media/lead-capture.4c3846c3.png";